export default __webpack_public_path__ + "static/media/solar_roof.9eb2e602.jpeg";